'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@petsmart-ui/sparky';
import cn from 'classnames';
import moment from 'moment';
import { useToggle } from 'react-use';
import { PreviewDrawer } from '../PreviewDrawer';
import type { PreviewProps } from './types';
import './Preview.scss';
export function Preview(t0) {
  const $ = _c(15);
  const {
    previewDate
  } = t0;
  const [isOpen, toggle] = useToggle(false);
  let t1;
  if ($[0] !== previewDate) {
    t1 = previewDate ? moment(previewDate).format("MMM D") : "";
    $[0] = previewDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !previewDate;
  let t3;
  if ($[2] !== t2) {
    t3 = cn("site-preview-btn", {
      "site-preview-btn__outline": t2
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3 || $[6] !== toggle) {
    t4 = <Button onClick={toggle} variant="primary" iconName="clock-outline" text={t1} className={t3} />;
    $[4] = t1;
    $[5] = t3;
    $[6] = toggle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isOpen || $[9] !== previewDate || $[10] !== toggle) {
    t5 = <PreviewDrawer isOpen={isOpen} previewDate={previewDate} onClose={toggle} />;
    $[8] = isOpen;
    $[9] = previewDate;
    $[10] = toggle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}